const EMPTY_ARRAY = [];
const computeWebForwardFormData = ({
  host,
  protocol,
  type,
  url
}) => {
  // pretty defensive code for flow to make sure we split an expected value
  let scheme = 'https';
  let targetUrl = '';
  if (['http://', 'https://', 'ftp://'].some(curr => url.startsWith(curr))) {
    [scheme, targetUrl] = url.split('://');
  } else {
    targetUrl = url;
  }

  // $FlowFixMe[incompatible-cast]: cannot cast since flow is unable to see that scheme can only be http, https or ftp
  const targetProtocol = `${scheme}://`;
  return {
    isNew: false,
    host,
    sourceProtocol: protocol,
    targetProtocol,
    targetUrl,
    type
  };
};
export const computeWebForward = ({
  host,
  sourceProtocol,
  targetProtocol,
  type,
  targetUrl
}) => ({
  host: host || '',
  protocol: sourceProtocol,
  url: `${targetProtocol}${targetUrl || ''}`,
  type
});
const computeNSAndRecordsFormData = (nsPayload, recordsPayload) => {
  let recordsType;
  if (nsPayload?.service === 'livedns' && !recordsPayload) {
    recordsType = 'migration';
  }
  let records;
  if (recordsPayload) {
    recordsType = recordsPayload.default === true ? 'default' : 'custom';
    records = recordsPayload.default === undefined ?
    // make sure we have a string for the form
    recordsPayload.text ?? '' : undefined;
  }
  const nameserversType = nsPayload?.service ?? 'livedns';
  return {
    nameserversType,
    nameservers: nameserversType === 'custom' ? (nsPayload?.addresses ?? EMPTY_ARRAY).join('\n') : undefined,
    recordsType,
    records
  };
};
export const initialFormData = {
  name: '',
  sharingId: '',
  orgname: '',
  default_registration: false,
  default_transfer: false
};
export const mapTemplateToFormData = ({
  name,
  // eslint-disable-next-line camelcase
  sharing_space,
  payload
}) => ({
  name,
  // eslint-disable-next-line camelcase
  sharingId: sharing_space?.id || '',
  // eslint-disable-next-line camelcase
  orgname: sharing_space?.name || '',
  nsAndRecords: payload['domain:nameservers'] || payload['dns:records'] ? computeNSAndRecordsFormData(payload['domain:nameservers'], payload['dns:records']) : undefined,
  webForwards: payload['domain:webredirs'] && payload['domain:webredirs'].values.map(forward => computeWebForwardFormData(forward)),
  mailboxes: payload['domain:mailboxes'] && {
    section: '1',
    // $FlowFixMe[unnecessary-optional-chain]
    mailbox1: payload['domain:mailboxes'].values[0]?.login ?? '',
    // $FlowFixMe[unnecessary-optional-chain]
    mailbox2: payload['domain:mailboxes'].values[1]?.login ?? ''
  },
  // always false by default since this info is outside of template.
  // Use `transformInitialValues` from EditForm to populate those values.
  default_transfer: false,
  default_registration: false
});
export const mapFormDataToTemplate = ({
  name,
  sharingId,
  nsAndRecords,
  webForwards,
  mailboxes,
  orgname
}, original = {}
// XXX: may be change for a custom type, the template is not saved yet and might not have a creation / update date
) => {
  const payload = {};
  if (nsAndRecords) {
    switch (nsAndRecords.nameserversType) {
      case 'custom':
        payload['domain:nameservers'] = {
          service: 'custom',
          addresses: (nsAndRecords.nameservers ?? '').split('\n').map(s => s.trim()).filter(Boolean)
        };
        break;
      default:
        payload['domain:nameservers'] = {
          service: 'livedns',
          addresses: []
        };

        // records configuration is set only when nameserversType is livedns
        switch (nsAndRecords.recordsType) {
          case 'custom':
            payload['dns:records'] = {
              text: nsAndRecords.records ?? ''
            };
            break;
          default:
            payload['dns:records'] = {
              default: true
            };
            break;
        }
        break;
    }
  }
  if (webForwards && webForwards.length > 0) {
    payload['domain:webredirs'] = {
      values: webForwards.map(computeWebForward)
    };
  }
  if (mailboxes) {
    payload['domain:mailboxes'] = {
      values: [mailboxes.mailbox1, mailboxes.mailbox2].filter(Boolean).map(login => ({
        login
      }))
    };
  }
  return {
    ...original,
    name,
    orgname,
    sharing_space: {
      id: sharingId,
      name: orgname
    },
    payload
  };
};